import { Timestamp } from 'firebase/firestore';
import { UPDATE_SOURCE, UpdateSource, LastUpdated, APPLICATION_STATUS, ApplicationStatus } from '@usacsmideo/types';

/**
 * Creates a lastUpdated object for Firestore writes
 */
export function createLastUpdated(
  source: UpdateSource,
  authorId: string
): LastUpdated {
  return {
    source,
    author: authorId,
    timestamp: Timestamp.now(),
  };
}

/**
 * Creates filterOptions timestamp updates based on applicationStatus changes
 */
export function getFilterOptionsForStatus(newStatus: ApplicationStatus): Record<string, Timestamp> {
  const timestamp = Timestamp.now();
  const updates: Record<string, Timestamp> = {};

  switch (newStatus) {
    case APPLICATION_STATUS.SUBMITTED:
      updates['filterOptions.submittedOn'] = timestamp;
      break;
    case APPLICATION_STATUS.PRINTABLE:
      updates['filterOptions.readiedOn'] = timestamp;
      break;
    case APPLICATION_STATUS.PRINTED:
      updates['filterOptions.printedOn'] = timestamp;
      break;
    case APPLICATION_STATUS.RELEASED:
      updates['filterOptions.releasedOn'] = timestamp;
      break;
    case APPLICATION_STATUS.CLOSED:
      updates['filterOptions.closedOn'] = timestamp;
      break;
    case APPLICATION_STATUS.ARCHIVED:
      updates['filterOptions.archivedOn'] = timestamp;
      break;
  }

  return updates;
}

// Re-export constants for convenience
export { UPDATE_SOURCE, APPLICATION_STATUS };
